<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex v-if="$canm('mnt')">
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">
                  {{ $t('future-workload') }}
                </h3>
              </div>
            </v-card-title>
            <v-card-text>
              {{ $t('issues-on-assets-report') }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text icon @click.native="$router.push({name: 'reports/common-future-workload'})">
                <v-icon>arrow_forward</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex v-if="$canm('mnt')">
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">
                  {{ $t('compliance-report') }}
                </h3>
              </div>
            </v-card-title>
            <v-card-text>
              {{ $t('assets-checklist-compliance-report') }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text icon @click.native="$router.push({name: 'reports/compliance-report'})">
                <v-icon>arrow_forward</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex v-if="$canm('mnt')">
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">
                  {{ $t('issued-commands') }}
                </h3>
              </div>
            </v-card-title>
            <v-card-text>
              {{ $t('issued-commands-report') }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text icon @click.native="$router.push({name: 'reports/issued-commands'})">
                <v-icon>arrow_forward</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex v-if="$canm('mnt')">
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">
                  {{ $t('device-statistics') }}
                </h3>
              </div>
            </v-card-title>
            <v-card-text>
              {{ $t('device-statistics-report') }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text icon @click.native="$router.push({name: 'reports/device-statistics'})">
                <v-icon>arrow_forward</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex v-if="$canm('mnt') && $cans('prg')">
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">
                  Přehled provedených prací
                </h3>
              </div>
            </v-card-title>
            <v-card-text>
              Přehled provedených prací v rámci údržby DP Praha
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text icon @click.native="$router.push({name: 'reports/prg'})">
                <v-icon>arrow_forward</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container justify-center v-if="noReportsAvailable">
      <v-layout justify-center row>
        <v-icon size="125" style="opacity: .7">no_sim</v-icon>
      </v-layout>
      <v-layout justify-center row>
        <h1 style="opacity: .5">
          {{ $t('reports.no-available') }}
        </h1>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    // summary negation of all conditions needed for each single report link to display
    noReportsAvailable () {
      return !(this.$canm('mnt') /* && other conditions */)
    }
  },
  methods: {}
}
</script>
